import React from "react";
import { Input as AntdInput } from "antd";
import type { InputProps as AntdInputProps } from "antd";

const { TextArea: AntdTextArea, Search: AntdSearch, Password: AntdPassword } = AntdInput;

export type InputProps = AntdInputProps;
export type TextAreaProps = React.ComponentProps<typeof AntdTextArea>;

/**
 * Input component - text input field
 */
const Input: React.FC<InputProps> & {
  TextArea: typeof AntdTextArea;
  Search: typeof AntdSearch;
  Password: typeof AntdPassword;
} = (props) => {
  return <AntdInput {...props} />;
};

// Attach static properties
Input.TextArea = AntdTextArea;
Input.Search = AntdSearch;
Input.Password = AntdPassword;

export default Input;
